
import Logo from "assets/new-hire-logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useIsMobile } from "hooks/useIsMobile";
import {  MenuOutlined} from "@ant-design/icons";
import { Menu, Popover } from "antd";
import type { MenuProps } from "antd";

type MenuItem = Required<MenuProps>["items"][number];

const Header = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const onClick: MenuProps["onClick"] = (e) => {
    navigate(e?.key);
  };

  const items: MenuItem[] = [
    {
      key: "/",
      label: "Home",
    },
    {
      key: "/about",
      label: "About Us",
    },
    {
      key: "/login",
      label: "Login",
    },
    {
      key: "/register",
      label: "Register",
    },
  ];

  return (
    <>
      <header
        className=" w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out"
        style={{ backgroundColor: "#EDF6F1" }}
      >
        <div className="max-w-6xl mx-auto pt-5 ">
          <div className="flex items-center justify-between px-5 md:px-0 h-16 md:h-20">
            <div className="shrink-0 mr-4">
              <img alt="" src={Logo} width={280} />
            </div>
            {isMobile ? (
              <Popover
                content={
                  <Menu onClick={onClick} className="w-52 px-2" mode="inline" items={items} />
                }
                title=""
                trigger="click"
              >
                <MenuOutlined className="text-3xl font-bold" />
              </Popover>
            ) : (
              <>
                {" "}
                <div>
                  <ul className="flex grow justify-end flex-wrap items-center gap-x-14">
                    <li>
                      <Link to="/" style={{ color: "#4B5563" }}>
                        Home
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/" style={{ color: "#4B5563" }}>
                        Resources
                      </Link>
                    </li> */}
                    <li>
                      <button
                        style={{ color: "#4B5563", cursor: "pointer" }}
                         onClick={() => navigate("/login?roleType=Enumerator")} >
                        Upload CV
                      </button>
                    </li>
                    <li>
                      <Link to="/about" style={{ color: "#4B5563", cursor: "pointer" }}>
                        About Us
                      </Link>
                    </li>
                    <li>
                      <button
                        style={{ color: "#4B5563", cursor: "pointer" }}
                        onClick={() => navigate("/login?roleType=Recruiter")}
                      >
                        Post Job
                      </button>
                    </li>
                  </ul>
                </div>
                <nav className="hidden md:flex ">
                  <ul className="flex grow justify-end flex-wrap items-center">
                    <li>
                      <a
                        href="/login"
                        className="font-medium  hover:text-gray-900 px-2 py-3 flex items-center transition duration-150 ease-in-out"
                        style={{ color: "#4B5563" }}
                      >
                        Login
                      </a>
                    </li>
                    <li>
                      <Link
                        to="/register"
                        className="btn-sm text-white bg-green-600 hover:bg-green-600 ml-3 px-5 py-3 rounded"
                      >
                        Register
                      </Link>
                    </li>
                  </ul>
                </nav>
              </>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;